import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../../constants";

export const sealSchema = {
    "documentSeal": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "sealExternalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "sealName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "sealDescription": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "sealData": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "sealFileSize": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "sealFileHash": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.FILE_HASH,
            value: "",
        },
        "sealType": {
            type: DATA_TYPE.ENUM,
            enum: "SealType",
            value: "",
        },
        "sealId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    }
} as const;
